const EXPENSES_CATEGORIES = {
    'Housing': ['Mortgage/Rent', 'Repair/Maintenance', 
                'Home Improvement', 'Property Tax', 
                'HOA fee', 'Furnishings'],

    'Utilities': ['Water', 'Gas', 'Electric', 'Solar', 
                'Landscaping', 'Trash/Recyling', 'Cellphone', 
                'Telephone', 'Internet/Cable/Sattelite/TV'],

    'Necessities': ['Food/Groceries', 'Medical out-of-pocket',
                'Childcare', 'Education'],

    'Insurance': ['Life', 'Medical', 'Home/Renter', 'Vision',
                'Dental', 'Vehicle', 'LTC', 'Disability',
                'H.S.A Contribution'],

    'Transportation': ['Vehicle Lease', 'Fuel', 'Toll', 'Train', 
                'Bus', 'Parking', 'Vehicle Maintenance', 'DMV fees'],

    'Personal Expenses': ['Chariable Donations', 'Vacation' ,
                'Travels', 'Entertainment', 'Hobbies', 
                'Clothing', 'Peronal Care', 'Gifts', 'Housekeeping',
                'Lessons', 'Sports', 'Subscriptions', 'Memberships',
                'Dining Out', 'Alinomy/Child Support', 'Other'],

    'Consumer Debt': ['Credit Card', "Personal Loans"],

    'Other': ['other'],
}

export default EXPENSES_CATEGORIES